import { useEffect } from 'react'

export const NO_REFERRER_META_NAME = 'referrer'
export const NO_REFERRER_META_CONTENT = 'no-referrer'

/** The booking uuid in these URLs is the capability key, so it must never leave in a Referer header. */
export function useNoReferrerPolicy() {
  useEffect(() => {
    const meta = document.createElement('meta')
    meta.name = NO_REFERRER_META_NAME
    meta.content = NO_REFERRER_META_CONTENT
    document.head.appendChild(meta)
    return () => meta.remove()
  }, [])
}
